module.exports = __webpack_public_path__ + "img/denmark-digestive-diseases-female.da7daa5f.png";